import React, { useCallback, useEffect, useState } from "react";

import { Loader, toast, withFeedback } from "@sicredi/react";
import ProductService from "#/api/requests/productService";
import { GlobalContext } from "#/context/Global";
import { PLAN_STATUS } from "#/constants";
import { useIsAuthenticated } from "#/hooks/useIsAuthenticated";
import { LAYOUT_CONFIG, Layout, Wrapper } from "#/components";
import { NoPlans, PlanCard } from "./components";

export const Home: React.FC = () => {
  const [{ isLoading }, setState] = useState<{
    isLoading: boolean;
  }>({ isLoading: false });
  const { user } = useIsAuthenticated();
  const {
    state: { products },
    dispatch,
    ActionTypes,
  } = GlobalContext();

  const fetchPlans = useCallback(async () => {
    try {
      setState((oldState) => ({ ...oldState, isLoading: true }));
      const planService = new ProductService(user?.access_token ?? "");
      const response = await planService.getProducts();
      dispatch({
        type: ActionTypes.SET_PRODUCTS,
        payload: response.filter(
          (product) =>
            product.status === PLAN_STATUS.CANCELED ||
            product.status === PLAN_STATUS.FINISHED
        ),
      });
    } catch (error: any) {
      if (error.status !== 404) {
        toast.error("Ocorreu um erro, tente novamente mais tarde");
      } else {
        dispatch({
          type: ActionTypes.SET_PRODUCTS,
          payload: [],
        });
      }
    } finally {
      setState((oldState) => ({ ...oldState, isLoading: false }));
    }
  }, [dispatch, ActionTypes, user]);

  useEffect(() => {
    if (user && !!!products) {
      fetchPlans();
    }
  }, [user, fetchPlans, products]);

  return user ? (
    <Layout {...LAYOUT_CONFIG.PLANS} isLoading={isLoading}>
      {!!products &&
        (products.length > 0 ? (
          <Wrapper>
            {products.map((product) => (
              <PlanCard key={product.insuranceNumber} product={product} />
            ))}
          </Wrapper>
        ) : (
          <NoPlans />
        ))}
    </Layout>
  ) : (
    <Loader show />
  );
};

export default withFeedback(Home);
